// src/data/pharmacistMockData.js

export const prescriptionMockData = [
  {
    id: 1,
    patient: 'John Doe',
    medication: 'Sertraline',
    doctor: 'Dr. Arvind Kumar',
    status: 'Pending',
    details: {
      dosage: '50mg',
      instructions: 'Take one tablet daily in the morning',
    },
  },
  {
    id: 2,
    patient: 'Jane Smith',
    medication: 'Lorazepam',
    doctor: 'Dr. Suresh Choudhury',
    status: 'Pending',
    details: {
      dosage: '1mg',
      instructions: 'Take one tablet before bedtime',
    },
  },
  {
    id: 3,
    patient: 'Emily Davis',
    medication: 'Fluoxetine',
    doctor: 'Dr. Dipankar Deka',
    status: 'Filled',
    details: {
      dosage: '20mg',
      instructions: 'Take one tablet daily after breakfast',
    },
  },
];
